// 登录态存储工具：token / userInfo 默认 24 小时后过期
const TOKEN_KEY = 'token'
const USER_INFO_KEY = 'userInfo'
const EXPIRE_KEY = 'tokenExpire'

// 默认有效期：24 小时
export const DEFAULT_EXPIRES = 24 * 60 * 60 * 1000

/**
 * 保存登录态
 * @param {string} token
 * @param {object} userInfo
 * @param {number} expires 有效期（毫秒），默认 24 小时
 */
export function setAuth(token, userInfo, expires = DEFAULT_EXPIRES) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo || {}))
  localStorage.setItem(EXPIRE_KEY, String(Date.now() + expires))
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_INFO_KEY)
  localStorage.removeItem(EXPIRE_KEY)
}

/** 登录态是否已过期（无过期时间视为已过期，兼容旧数据需重新登录） */
export function isExpired() {
  const expire = localStorage.getItem(EXPIRE_KEY)
  if (!expire) return true
  return Date.now() > Number(expire)
}

/** 获取 token，过期则自动清除并返回 null */
export function getToken() {
  const token = localStorage.getItem(TOKEN_KEY)
  if (!token) return null
  if (isExpired()) {
    clearAuth()
    return null
  }
  return token
}

/** 获取用户信息，过期则返回空对象 */
export function getUserInfo() {
  if (!getToken()) return {}
  try {
    return JSON.parse(localStorage.getItem(USER_INFO_KEY) || '{}')
  } catch (e) {
    return {}
  }
}

/** 更新用户信息（不改变已有过期时间） */
export function setUserInfo(userInfo) {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo || {}))
}
